import { useEffect } from "react";
import { Grid, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  JOrder,
  resetForm,
  setChangeAdminNoteDialog,
} from "../../../../app/slices/jomla/orderSlice";
import {
  HiOutlinePencilSquare,
  HiOutlineChatBubbleBottomCenterText,
} from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const ChangeAdminNoteForm = (props) => {
  const dispatch = useDispatch();

  const _JOrder = useSelector((state) => state.jOrder.changeAdminNote);
  const _SearchBody = useSelector((state) => state.jOrder.searchBody);

  const { control, reset, handleSubmit } = useForm({
    defaultValues: _JOrder.form,
  });

  const onSubmit = (data) => {
    dispatch(
      JOrder.changeAdminNote(
        _JOrder.form.order_id,
        {
          admin_note: data.admin_note,
        },
        _SearchBody,
        props.orderDetails
      )
    );
  };

  useEffect(() => {
    reset({ ..._JOrder.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_JOrder.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDialog = () => {
    dispatch(setChangeAdminNoteDialog({}));
  };

  return (
    <FormDialog
      open={_JOrder.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlinePencilSquare />}
      title={"ملاحظات الطلبية"}
      subtitle="قم بتحديث ملاحظات الطلبية ثم احفظ التغييرات"
      onSubmit={handleSubmit(onSubmit)}
      saving={_JOrder.loading}
      loading={_JOrder.loading}
    >
      <SectionCard
        icon={<HiOutlineChatBubbleBottomCenterText />}
        title="الملاحظات"
      >
        <Grid item xs={12}>
          <Controller
            control={control}
            name={"admin_note"}
            render={({ field }) => (
              <TextField
                size="small"
                label="الملاحظات"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default ChangeAdminNoteForm;
